import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
    EmvioRow as Row,
    EmvioCard as Card,
    EmvioLoadingSpinner as LoadingSpinner
} from '@nexio/emvio-util-ui';
import { EmvioCaretDownIcon as CaretDown } from '@nexio/emvio-form-components';
import {
    getSelectedMerchantIdsString
} from '../../MerchantSelector/merchantSelectorViewState';
import {
    doesPropExistAndHasItChanged,
    prettifyMoney
} from '@nexio/emvio-util-app';
import { get, size, sortBy, reverse } from 'lodash';
import classNames from 'classnames';
import { reserveSummaryShape } from '../../../utils/propTypes';
import { getReserveSummaries as fetchReserveSummaries } from '../reservesActions';
import { getReserveSummaries, getIsReserveSummariesLoading, getIsReserveSummariesLoaded } from '../reservesEntity';
import { getMerchantsMapper } from '../../Merchants/merchantsEntity';
import './ReservesSummary.scss';

export class ReservesSummary extends React.Component {
    static propTypes = {
        merchantMap: PropTypes.any,
        reserveSummaries: PropTypes.arrayOf(reserveSummaryShape),
        areReserveSummariesLoading: PropTypes.bool,
        areReserveSummariesLoaded: PropTypes.bool,
        onGetReserveSummaries: PropTypes.func.isRequired,
        selectedMerchantsString: PropTypes.string
    };

    constructor(props) {
        super(props);

        this.state = {
            reserveBalance: null,
            areMerchantBalancesOpen: true
        };

        this.renderReservesBalance = this.renderReservesBalance.bind(this);
        this.renderMerchantBalances = this.renderMerchantBalances.bind(this);
        this.handleToggleMerchantBalances = this.handleToggleMerchantBalances.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (doesPropExistAndHasItChanged(prevProps, this.props, 'selectedMerchantsString')
            && this.props.areReserveSummariesLoaded) {
            this.props.onGetReserveSummaries(this.props.selectedMerchantsString);
        }
    }

    handleToggleMerchantBalances() {
        this.setState((prevState) => {
            return { areMerchantBalancesOpen: !prevState.areMerchantBalancesOpen };
        });
    }

    renderReservesBalance() {
        let calculatedBalance = 0;
        if (size(this.props.reserveSummaries)) {
            calculatedBalance = this.props.reserveSummaries.reduce((acc, merchantSummary) => {
                return acc + merchantSummary.amount;
            }, 0);
        }

        return (
            <div className="reserves-balance">
                <div className="reserves-balance-content">
                    <span>Reserve Balance:</span>
                    <span className="reserves-dollar-amount">{prettifyMoney(calculatedBalance)}</span>
                </div>
                {size(this.props.reserveSummaries) > 1 ? <div onClick={this.handleToggleMerchantBalances}
                    className={classNames('mobile-show-balances-button',
                        { 'closed': !this.state.areMerchantBalancesOpen })}>
                    {this.state.areMerchantBalancesOpen ? 'Hide Details' : 'Show Details'}
                    <div className={classNames('caret', { 'closed': !this.state.areMerchantBalancesOpen })}>
                        <CaretDown />
                    </div>
                </div> : null}
            </div>
        );
    }

    renderMerchantBalances() {
        const merchantSummaries = reverse(sortBy([...get(this.props, 'reserveSummaries', [])], 'amount'));

        if (this.state.areMerchantBalancesOpen && size(merchantSummaries) > 1) {
            const numberOfBalancesToShow = 5;
            if (merchantSummaries.length > numberOfBalancesToShow) {
                const amount = merchantSummaries.splice(numberOfBalancesToShow - 1).reduce((acc, merchantSummary) =>
                    acc + merchantSummary.amount, 0
                );

                merchantSummaries[4] = { amount };
            }

            return (
                <div className={classNames('merchant-balances')}>
                    {merchantSummaries.map((merchantSummary) => {
                        const merchantName = get(this.props.merchantMap, merchantSummary.merchantId, 'Other');
                        const merchantId = merchantSummary.merchantId;

                        return (
                            <div className="merchant-balance" key={merchantId || 'other'}>
                                <div className="merchant-detail">
                                    <div className="merchant-name">
                                        {merchantName}
                                    </div>
                                    <div className="merchant-id">
                                        {merchantId}
                                    </div>
                                </div>
                                <div className="merchant-dollar-amount">
                                    {prettifyMoney(merchantSummary.amount)}
                                </div>
                            </div>
                        );
                    })}
                </div>
            );
        }

        return null;
    }

    render() {
        return (
            <Row className="emvio-reserves-summary">
                <Card className="reserves-summary-card grow-height">
                    {this.props.reserveSummaries && this.props.merchantMap ?
                        <div className="reserves-summary">
                            {this.renderReservesBalance()}
                            {this.renderMerchantBalances()}
                        </div>
                        : <LoadingSpinner relative />
                    }
                </Card>
            </Row>
        );
    }
}

function mapStateToProps(state) {
    return {
        merchantMap: getMerchantsMapper(state),
        reserveSummaries: getReserveSummaries(state),
        areReserveSummariesLoading: getIsReserveSummariesLoading(state),
        areReserveSummariesLoaded: getIsReserveSummariesLoaded(state),
        selectedMerchantsString: getSelectedMerchantIdsString(state)
    };
}

function mapDispatchToProps(dispatch) {

    return {
        onGetReserveSummaries: (merchantIds) => dispatch(fetchReserveSummaries(merchantIds))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReservesSummary);
